export const currencyNames = {
  USD: 'US$',
  HKD: 'HK$',
  CNY: 'CN¥',
  TWD: 'TW$',
};

export const exchangeRates: { [key: string]: number } = {
  USD: 1,
  HKD: 7.77,
  CNY: 7.12,
  TWD: 32.18,
};

export const cashOutRequirements: { [key: string]: number } = {
  USD: 120,
  HKD: 1000,
  CNY: 900,
  TWD: 4000,
};

export const smartParentPlanPrices = {
  USD: {
    originalPrice: 399,
    referralPrice: 299,
    specialPrice: 383,
    tier1PurchaseReward: 60,
    tier1RepurchaseReward: 36,
    tier2PurchaseReward: 30,
    tier2RepurchaseReward: 18,
  },
  HKD: {
    originalPrice: 3130,
    referralPrice: 2330,
    specialPrice: 3005,
    tier1PurchaseReward: 500,
    tier1RepurchaseReward: 300,
    tier2PurchaseReward: 250,
    tier2RepurchaseReward: 150,
  },
  CNY: {
    originalPrice: 3088,
    referralPrice: 2288,
    specialPrice: 2988,
    tier1PurchaseReward: 500,
    tier1RepurchaseReward: 300,
    tier2PurchaseReward: 250,
    tier2RepurchaseReward: 150,
  },
  TWD: {
    originalPrice: 12800,
    referralPrice: 9600,
    specialPrice: 12288,
    tier1PurchaseReward: 2000,
    tier1RepurchaseReward: 1200,
    tier2PurchaseReward: 1000,
    tier2RepurchaseReward: 600,
  },
};

export const WEATeacherPlanPrice = {
  USD: {
    originalPrice: 34.99,
    specialPrice: 29.99,
    referralPrice: 19.99,
    tier1PurchaseReward: 5,
    tier2PurchaseReward: 3,
    examplePrice: 10,
  },
  HKD: {
    originalPrice: 272,
    specialPrice: 233,
    referralPrice: 155,
    tier1PurchaseReward: 39,
    tier2PurchaseReward: 23,
    examplePrice: 78,
  },
  TWD: {
    originalPrice: 1212,
    specialPrice: 960,
    referralPrice: 640,
    tier1PurchaseReward: 160,
    tier2PurchaseReward: 96,
    examplePrice: 320,
  },
  CNY: {
    originalPrice: 250,
    specialPrice: 215,
    referralPrice: 142,
    tier1PurchaseReward: 36,
    tier2PurchaseReward: 22,
    examplePrice: 72,
  },
};

export const JOYAJOYPrice = {
  USD: {
    JOYAJOYCreatorMonthly: 39.99,
  },
  HKD: {
    JOYAJOYCreatorMonthly: 318,
  },
  TWD: {
    JOYAJOYCreatorMonthly: 1190,
  },
  CNY: {
    JOYAJOYCreatorMonthly: 258,
  },
};
